import React from "react";
import { BiCalendarEdit, BiCode, BiUpload, BiTrophy } from "react-icons/bi";

const Timeline = () => {
  const timelineData = [
    {
      phase: "التسجيل",
      date: "8 إلى 20 نوفمبر",
      description: "فتح باب التسجيل للمطورين",
      Icon: BiCalendarEdit,
      colorClass: "bg-yellow",
      textColorClass: "text-yellow"
    },
    {
      phase: "التطوير",
      date: "20 إلى 30 نوفمبر",
      description: "فترة العمل على المشاريع",
      Icon: BiCode,
      colorClass: "bg-emerald-500",
      textColorClass: "text-emerald-500"
    },
    {
      phase: "التسليم والتحكيم",
      date: "30 نوفمبر إلى 3 ديسمبر",
      description: "رفع المشاريع وتقييمها",
      Icon: BiUpload,
      colorClass: "bg-purple",
      textColorClass: "text-purple"
    },
    {
      phase: "إعلان النتائج",
      date: "5 ديسمبر",
      description: "إعلان الفائزين وتكريمهم",
      Icon: BiTrophy,
      colorClass: "bg-yellow",
      textColorClass: "text-yellow"
    }
  ];

  return (
    <section id="timeline" className="relative min-h-screen py-20 md:py-32 bg-blue">
              <div className="absolute z-10 top-0 left-0 w-full overflow-hidden leading-none">
        <svg
          className="relative block w-full h-12"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            className="fill-dark-blue"
          ></path>
        </svg>
      </div>
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-semibold text-white mb-4 uppercase tracking-wide">
              الجدول الزمني
            </h2>
            <div className="w-24 h-1 bg-yellow mx-auto rounded-full mb-6"></div>
            <p className="text-xl text-white/80">رحلة الهاكاثون من البداية للنهاية</p>
          </div>

          {/* Desktop Timeline */}
          <div className="hidden md:block mt-48">
            <div className="relative py-32">
              {/* Timeline Line */}
              <div className="absolute top-1/2 left-0 right-0 h-1 bg-white/20 transform -translate-y-1/2 z-0"></div>
              
              <div className="grid grid-cols-4 gap-8">
                {timelineData.map((item, index) => {
                  const IconComponent = item.Icon;
                  const isEven = index % 2 === 0;
                  
                  return (
                    <div key={index} className="relative">
                      {/* Timeline Dot - centered on the line */}
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20">
                        <div 
                          className={`w-8 h-8 rounded-full border-4 border-blue ${item.colorClass} flex items-center justify-center`}
                        >
                          <div className={`w-2 h-2 rounded-full ${item.colorClass}`}></div>
                        </div>
                      </div>

                      {/* Card - positioned above or below the line */}
                      <div className={`absolute left-1/2 transform -translate-x-1/2 w-full ${
                        isEven 
                          ? 'bottom-1/2 mb-8' 
                          : 'top-1/2 mt-8'
                      }`}>
                        <div className={``}>
                          <div className={`text-4xl mb-3 flex items-center justify-center ${item.textColorClass}`}>
                            <IconComponent />
                          </div>
                          <h3 className="text-lg font-medium text-white mb-2 text-center">{item.phase}</h3>
                          <div 
                            className={`text-xs font-medium mb-3 text-center px-3 py-1 rounded-full w-fit mx-auto ${item.colorClass} bg-opacity-30 ${item.textColorClass}`}
                          >
                            {item.date}
                          </div>
                          <p className="text-white/70 text-xs text-center leading-relaxed">{item.description}</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Mobile Timeline */}
          <div className="md:hidden space-y-6">
            {timelineData.map((item, index) => {
              const IconComponent = item.Icon;
              return (
                <div key={index} className="relative pr-12">
                  {/* Timeline Line */}
                  {index < timelineData.length - 1 && (
                    <div className="absolute top-16 right-5 w-0.5 h-full bg-white/20"></div>
                  )}
                  
                  {/* Timeline Dot */}
                  <div 
                    className={`absolute top-6 right-2 w-6 h-6 rounded-full border-4 border-blue ${item.colorClass}`}
                  ></div>

                  {/* Card */}
                  <div className="bg-white/5 rounded-2xl p-6 border border-white/10">
                    <div className={`text-4xl mb-3 flex items-center justify-center ${item.textColorClass}`}>
                      <IconComponent />
                    </div>
                    <h3 className="text-xl font-medium text-white mb-2 text-right">{item.phase}</h3>
                    <div 
                      className={`text-sm font-medium mb-3 text-center px-3 py-1 rounded-full inline-block ${item.colorClass}/20 ${item.textColorClass}`}
                    >
                      {item.date}
                    </div>
                    <p className="text-white/70 text-sm text-right leading-relaxed">{item.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline;

